import { render, staticRenderFns } from "./BaseInputError.vue?vue&type=template&id=7e464d9e"
import script from "./BaseInputError.vue?vue&type=script&lang=js"
export * from "./BaseInputError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports